enum SimpleLoyaltySignupMode {
  OrderSummary = 1,
  PaymentCompleted = 2,
  PaymentCompletedForced = 3,
}

export { SimpleLoyaltySignupMode };
